import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isEnglishPath } from '../data/i18nMap';

// Keeps <html lang> in sync with the current route (en under /en/, fr elsewhere).
const LangSync = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    document.documentElement.lang = isEnglishPath(pathname) ? 'en' : 'fr';
  }, [pathname]);
  return null;
};

export default LangSync;
